import React, { Component, createRef } from 'react';
import cx from 'classnames';

import downArrow from '~assets/chevron-down.svg';
import downArrowActive from '~assets/chevron-up.svg';

import styles from './styles.module.scss';

interface Props {
  title: string;
  className?: string;
  relativeDropdown?: boolean;
  textClassName?: string;
  open?: boolean;
  fullWidth?: boolean;
  marginBottom: string;
  invesmentFilter?: boolean;
  orangeBg?: boolean;
}

interface State {
  showDropdown: boolean;
}

class Dropdown extends Component<Props, State> {
  static defaultProps = {
    relativeDropdown: false,
    fullWidth: false,
  };

  state = {
    showDropdown: !!this.props.open
  };

  dropdownRef: any = createRef();

  componentDidMount() {
    const { relativeDropdown } = this.props;
    if (!relativeDropdown) {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }

  componentWillUnmount() {
    const { relativeDropdown } = this.props;
    if (!relativeDropdown) {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  handleClickOutside = event => {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ showDropdown: false });
    }
  };

  handleToggleDropdown = () => {
    this.setState(prevState => ({ showDropdown: !prevState.showDropdown }));
  };

  render() {
    const { title, children, className, relativeDropdown, textClassName, fullWidth, marginBottom, invesmentFilter, orangeBg } = this.props;
    const { showDropdown } = this.state;

    return (
      <div className={cx(`relative ${className}`, { [styles.containerActive]: showDropdown, [styles.orangeBg]: orangeBg })} 
        ref={this.dropdownRef} style={{marginBottom: showDropdown ? marginBottom+'px' : '0px'}}>
        <div
          className={cx('row', styles.container, { [styles.active]: showDropdown,  })}
          onClick={this.handleToggleDropdown}
        >
          <span className={cx(styles.title, textClassName, { 'text-small': !textClassName })}>{title}</span>
          <img className="m-left-auto m-right-2" src={showDropdown ? downArrowActive : downArrow} />
        </div>
        {showDropdown && (
          <div
            className={cx(styles.dropdown, {
              absolute: !relativeDropdown,
              [styles.blueDropdown]: !relativeDropdown,
              [styles.fixed]: fullWidth,
              [styles.invesmentFilter]: invesmentFilter
            })}
          >
            {children}
          </div>
        )}
      </div>
    );
  }
}

export default Dropdown;
